import { Sparkles } from "lucide-react";
import { useUsage } from "@/lib/usage";

/** Compact "N/15 this month" chip for the header. Transparent when loading
 *  so it doesn't flash a bogus zero before the first fetch resolves. */
export default function UsageChip() {
  const { used, limit, percent, nearLimit, overLimit, loading, isPro, isStarter, plan } = useUsage();
  if (loading || isPro || isStarter || plan === "free") return null;

  // Colour ramp — slate normal, amber at 80%, rose when hard-capped.
  const tone = overLimit
    ? "border-rose-200 bg-rose-50 text-rose-900"
    : nearLimit
      ? "border-amber-200 bg-amber-50 text-amber-900"
      : "border-slate-200 bg-slate-50 text-slate-700";

  const barTone = overLimit
    ? "bg-rose-500"
    : nearLimit
      ? "bg-amber-500"
      : "bg-[#0053DA]";

  return (
    <div
      className={`hidden h-9 min-w-0 shrink-0 items-center gap-2 rounded-full border px-3 text-xs font-medium sm:inline-flex ${tone}`}
      data-testid="usage-chip"
      title={`${used} of ${limit} AI drafts used this month. Resets on the 1st.`}
    >
      <Sparkles className="h-3.5 w-3.5 opacity-70" />
      <span className="font-mono font-semibold tabular-nums">
        {used}/{limit}
      </span>
      <span className="text-slate-400">this month</span>
      {/* Tiny inline progress bar */}
      <span className="relative inline-block h-1 w-10 overflow-hidden rounded-full bg-slate-200" aria-hidden="true">
        <span
          className={`absolute inset-y-0 left-0 ${barTone}`}
          style={{ width: `${Math.max(2, percent)}%` }}
        />
      </span>
    </div>
  );
}
